import React from 'react';
import ReactStars from 'react-rating-stars-component';
import PropTypes from 'prop-types';
import './styles.scss';
import { isIE } from '../../../Share/utils';

function StarGroup({
  handleChange = () => {},
  defaultRate = 0,
  activeColor = '#ffd700',
  size = 25,
  count = 5,
  classNames,
}) {
  return (
    <ReactStars
      count={count}
      classNames={classNames}
      value={defaultRate}
      onChange={handleChange}
      color={isIE ? '#ffe7ce' : '#FFF'}
      size={size}
      activeColor={activeColor}
    />
  );
}

StarGroup.propTypes = {
  defaultRate: PropTypes.number,
  handleChange: PropTypes.func,
  activeColor: PropTypes.string,
  size: PropTypes.number,
  count: PropTypes.number,
};



export default StarGroup;
